import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { GoogleAnalytics } from './google-analytics';

@Component({
  selector: 'app-cookie-consent-dialog',
  templateUrl: './cookie-consent.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, RouterLink],
})
export class CookieConsentDialog {
  ga = inject(GoogleAnalytics);

  save(consent: boolean) {
    this.ga.setConsent(consent);
  }
}
